import React from 'react';
import { camelCase, startCase } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withNamespaces } from 'react-i18next';
import statusClasses from '../../../utils/Status';
import RoundedTitle from '../RoundedTitle';

const StatusLabel = (props) => {
  const { t, status, className, withClose = false, onClose = () => {}, formattedStatus } = props;
  const statusClassNames = classNames(formattedStatus ? statusClasses(formattedStatus) : statusClasses(status), 'status-label', className);
  const cleanStatus = status ? t(camelCase(`status${startCase(status)}`)) : formattedStatus;

  return <RoundedTitle title={cleanStatus} className={statusClassNames} withClose={withClose} onClose={onClose} />;
};

StatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
  formattedStatus: PropTypes.string,
};

export default withNamespaces()(StatusLabel);
